module.exports = __webpack_public_path__ + "img/15_29.df2e9120.png";